import Vuex from 'vuex'
import $ from 'jquery'

KCVS.Stores.ReportRowsStore = new Vuex.Store
  state:
    projectPartnerReportPeriodId: null
    projectPartnerId: null
    informativeFields: {}
    invoiceRows: []
    iceboxRows: []
    selectedInvoiceRowIds: []
    selectedIceboxRowIds: []
    AUTH_TOKEN: $('meta[name="csrf-token"]').attr('content')
  mutations:
    addInvoiceRowId: (state, id) ->
      state.selectedInvoiceRowIds.push(id) unless _.indexOf(state.selectedInvoiceRowIds, id) > -1

    removeInvoiceRowId: (state, id) ->
      rowIndex = _.indexOf(state.selectedInvoiceRowIds, id)
      state.selectedInvoiceRowIds.splice(rowIndex, 1)

    selectAllInvoiceRows: (state) ->
      state.selectedInvoiceRowIds = state.invoiceRows.map((r) -> r.id)

    deselectAllInvoiceRows: (state) ->
      state.selectedInvoiceRowIds = []

    addIceboxRowId: (state, id) ->
      state.selectedIceboxRowIds.push(id) unless _.indexOf(state.selectedIceboxRowIds, id) > -1

    removeIceboxRowId: (state, id) ->
      rowIndex = _.indexOf(state.selectedIceboxRowIds, id)
      state.selectedIceboxRowIds.splice(rowIndex, 1)

    selectAllIceboxRows: (state) ->
      state.selectedIceboxRowIds = state.iceboxRows.map((r) -> r.id)

    deselectAllIceboxRows: (state) ->
      state.selectedIceboxRowIds = []

  actions:
    removeInvoiceRowFromCollection: (store, id) ->
      arrayRow = _.find(store.state.invoiceRows, (s_row) -> s_row.id == id )
      deletedRowIndex = _.indexOf(store.state.invoiceRows, arrayRow)
      if deletedRowIndex >= 0
        store.state.invoiceRows.splice(deletedRowIndex, 1)
      store.commit('removeInvoiceRowId')

    removeIceboxRowFromCollection: (store, id) ->
      arrayRow = _.find(store.state.iceboxRows, (s_row) -> s_row.id == id )
      deletedRowIndex = _.indexOf(store.state.iceboxRows, arrayRow)
      if deletedRowIndex >= 0
        store.state.iceboxRows.splice(deletedRowIndex, 1)
      store.commit('removeIceboxRowId')

    fetchInvoiceRows: (store) ->
      new Promise (resolve, reject) =>
        $.ajax
          url: "/admin/project_partner_report_periods/#{store.state.projectPartnerReportPeriodId}/report_rows.json"
          method: 'GET'
          dataType: 'JSON'
          success: (data) =>
            store.state.invoiceRows = data
            resolve(data)
          error: reject

    destroyInvoiceRow: (store, row) ->
      new Promise (resolve, reject) =>
        $.ajax
          dataType: 'JSON',
          url: "/admin/report_rows/#{row.id}"
          method: 'DELETE'
          data:
            authenticity_token: store.state.AUTH_TOKEN
          success: =>
            store.dispatch('removeInvoiceRowFromCollection', row.id)
            resolve()
          error: reject

    destroyIceboxRow: (store, row) ->
      new Promise (resolve, reject) =>
        $.ajax
          dataType: 'JSON',
          url: "/admin/icebox_rows/#{row.id}"
          method: 'DELETE'
          data:
            authenticity_token: store.state.AUTH_TOKEN
          success: =>
            store.dispatch('removeIceboxRowFromCollection', row.id)
            resolve()
          error: reject

    updateInvoiceRow: (store, row) ->
      new Promise (resolve, reject) =>
        $.ajax
          dataType: 'JSON',
          url: "/admin/report_rows/#{row.id}"
          method: 'PUT'
          data: $.extend(row, { authenticity_token: store.state.AUTH_TOKEN })
          success: =>
            arrayRow = _.find(store.state.invoiceRows, (s_row) -> s_row.id == row.id )
            oldRowIndex = _.indexOf(store.state.invoiceRows, arrayRow)
            store.state.invoiceRows.splice(oldRowIndex, 1, row)
            resolve()
          error: (data) =>
            reject(data)

    moveSelectedRowsToIcebox: (store, reason) ->
      new Promise (resolve, reject) =>
        $.ajax
          dataType: 'JSON',
          url: "/admin/report_rows/move_to_icebox"
          method: 'POST',
          data:
            iceboxing_reason: reason
            row_ids: store.state.selectedInvoiceRowIds
            authenticity_token: store.state.AUTH_TOKEN
          success: =>
            store.state.selectedInvoiceRowIds.forEach((id) -> store.dispatch('removeInvoiceRowFromCollection', id))
            store.dispatch('fetchIceboxRows')
            resolve()
          error: reject

    fetchIceboxRows: (store) ->
      new Promise (resolve, reject) =>
        $.ajax
          url: "/admin/project_partner_report_periods/#{store.state.projectPartnerReportPeriodId}/icebox_rows.json"
          method: 'GET'
          dataType: 'JSON'
          success: (data) =>
            store.state.iceboxRows = data
            resolve(data)
          error: reject

    updateIceboxRow: (store, row) ->
      new Promise (resolve, reject) =>
        $.ajax
          dataType: 'JSON',
          url: "/admin/icebox_rows/#{row.id}"
          method: 'PUT'
          data: $.extend(row, { authenticity_token: store.state.AUTH_TOKEN })
          success: =>
            arrayRow = _.find(store.state.iceboxRows, (s_row) -> s_row.id == row.id )
            oldRowIndex = _.indexOf(store.state.iceboxRows, arrayRow)
            store.state.iceboxRows.splice(oldRowIndex, 1, row)
            resolve()
          error: reject

    moveSelectedRowsFromIcebox: (store, projectPartnerReportPeriodId) ->
      new Promise (resolve, reject) =>
        $.ajax
          dataType: 'JSON',
          url: "/admin/icebox_rows/move_to_project_partner_report_period"
          method: 'POST'
          data:
            project_partner_report_period_id: projectPartnerReportPeriodId
            row_ids: store.state.selectedIceboxRowIds
            authenticity_token: store.state.AUTH_TOKEN
          success: ->
            store.state.selectedIceboxRowIds.forEach((id) -> store.dispatch('removeIceboxRowFromCollection', id))
            if parseInt(projectPartnerReportPeriodId) == store.state.projectPartnerReportPeriodId
              store.dispatch('fetchInvoiceRows')
            resolve()
          error: reject


export default KCVS.Stores.ReportRowsStore